import { FormikProps, useFormik } from 'formik';
import { IAccountDeleteRequestPayload } from 'shared/interfaces/IAccount';
import * as yup from 'yup';

type FormProps = {
  onSubmit: (values: IAccountDeleteRequestPayload) => void;
};

export const useAccountDeletionForm = ({ onSubmit }: FormProps) => {
  const initialValues: IAccountDeleteRequestPayload = {
    reason: '',
    message: '',
  };

  const validationScheme: yup.SchemaOf<IAccountDeleteRequestPayload> = yup.object({
    reason: yup.string().required('Reason is required'),
    message: yup.string().notRequired(),
  });

  const form: FormikProps<IAccountDeleteRequestPayload> = useFormik({
    initialValues,
    validationSchema: validationScheme,
    validateOnBlur: true,
    onSubmit: (values) => {
      onSubmit(values);
    },
    enableReinitialize: true,
  });

  return {
    form,
  };
};
